import React, { PureComponent } from 'react';

const USD = (val)=> parseFloat(val).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
class CryptoTransactionsView extends PureComponent {
  render() {
    const {
      cryptoTransactions,
    } = this.props;

    return (
      <div className="bitcoin-trades-page page">
        <h2>Crypto Transactions</h2>
        <table>
          <thead>
          <tr>
            <th>Type</th>
            <th>Product</th>
            <th>Market</th>
            <th>Transaction Price</th>
            <th>Current Price</th>
            <th>Pivot Price</th>
            <th>Time</th>
          </tr>
          </thead>
          <tbody>
          {cryptoTransactions.map((cryptoTransaction, i) => (
            <tr key={i}>
              <td>{cryptoTransaction.type}</td>
              <td>{cryptoTransaction.product}</td>
              <td>{cryptoTransaction.market}</td>
              <td>{USD(cryptoTransaction.price)}</td>
              <td>{USD(cryptoTransaction.currentPrice)}</td>
              <td>{USD(cryptoTransaction.pivotPrice)}</td>
              <td>{(new Date(cryptoTransaction.timestamp)).toLocaleString()}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default CryptoTransactionsView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/CryptoTransactions/CryptoTransactions.view.js